import { default as _  } from 'lodash';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GridService } from 'app/Shared/Services/grid.service';
import { UserService } from 'app/Shared/Services/user.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { Subscription } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InputMaskModule } from "primeng/inputmask";

@Component({
    selector: 'app-quick-search',
    imports: [FormsModule, CommonModule, MatTooltipModule, InputMaskModule],
    templateUrl: './quick-search.component.html',
    styleUrl: './quick-search.component.scss'
})
export class QuickSearchComponent {

  @Input('DefaultFilterArray') DefaultFilterArray: any;
  @Input('QuickSearchFilterArray') QuickSearchFilterArray: any;
  @Input('FilterFieldDefaultValues') FilterFieldDefaultValues: any;
  @Output() updateDefaultArray: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearQuickSearch: EventEmitter<any> = new EventEmitter<any>();
  

  quickSearchDataArray: any = [];

  subscription!: Subscription;
  constructor( private gridService: GridService,
    public userService: UserService,
    public constantService: ConstantService
  ){}

  ngOnInit() {
    this.quickSearchDataArray = [];

    if(this.DefaultFilterArray.length > 0 && this.QuickSearchFilterArray.length > 0) {
      for (let i=0; i<this.DefaultFilterArray.length; i++) {
        for (let j=0; j<this.QuickSearchFilterArray.length; j++) {
          if (this.QuickSearchFilterArray[j].columnname === this.DefaultFilterArray[i].columnname) {
            this.DefaultFilterArray[i]['placeholder'] = this.QuickSearchFilterArray[j].placeholder;
            this.DefaultFilterArray[i]['className'] = this.QuickSearchFilterArray[j].className;
            this.DefaultFilterArray[i]['isLarge'] = this.QuickSearchFilterArray[j].isLarge;
            this.DefaultFilterArray[i]['isXLarge'] = this.QuickSearchFilterArray[j].isXLarge;
            this.DefaultFilterArray[i]['fieldtype'] = this.QuickSearchFilterArray[j].fieldtype;
            this.DefaultFilterArray[i]['mask'] = this.QuickSearchFilterArray[j].mask;
            this.DefaultFilterArray[i]['slotchar'] = this.QuickSearchFilterArray[j].slotchar;
            this.DefaultFilterArray[i]['preserveUserOptedValues'] = this.QuickSearchFilterArray[j].preserveUserOptedValues;
            let replicaItem = {...this.DefaultFilterArray[i]};
            replicaItem['values'] = (['skip', 'array'].includes(this.QuickSearchFilterArray[j].datatype.toLowerCase()) ? [] : this.DefaultFilterArray[i].values);
            this.quickSearchDataArray.push(replicaItem);
          }
        }
      }

    }
    
  }

  quickSearch() {
    let payload: any = {};
    if(this.quickSearchDataArray.length > 0) {
      for (let i=0; i<this.quickSearchDataArray.length; i++) {
        let FilterFieldArray = this.DefaultFilterArray.filter((rowbj: any) => (rowbj.columnname === this.quickSearchDataArray[i].columnname)); // Receive Field from Default Filter Field Array 
        payload[this.quickSearchDataArray[i].columnname] = ((['skip', 'array', 'daterange'].includes(this.quickSearchDataArray[i].datatype.toLowerCase()) && this.quickSearchDataArray[i].values.length > 0) ? this.checkValidValues(this.quickSearchDataArray[i]) : (this.quickSearchDataArray[i].preserveUserOptedValues ? FilterFieldArray[0].values : (this.FilterFieldDefaultValues && this.FilterFieldDefaultValues[this.quickSearchDataArray[i].columnname] ? this.FilterFieldDefaultValues[this.quickSearchDataArray[i].columnname] : this.quickSearchDataArray[i].values)));
      }
    }

    this.gridService.quickSearchByValues(this.DefaultFilterArray,payload);
    /* Catch User Action Log */
      this.userService.logUserActivity("User Applied Quick Search", this.constantService.getApplicationName(), {
        'Text1': this.userService.userFirstName + ' Applied Quick Search Filter in ' + this.constantService.getApplicationName(),
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    this.updateDefaultArray.emit(this.DefaultFilterArray);
  }

  checkValidValues(quickSearchField: any) {
    let defaultFilterField = this.DefaultFilterArray.filter((fieldObj: any) => (fieldObj.columnname === quickSearchField.columnname));
    let quickFieldValues = quickSearchField.values.split(",");
    let validValueList: any = [];

    if(['skip', 'array'].includes(quickSearchField.datatype.toLowerCase())) {
      let AllowedValidValueList = defaultFilterField[0].dropdownvalue.map((defFieldObj: any) => (defFieldObj.value));
      validValueList = _.intersection(AllowedValidValueList, quickFieldValues);
    } else if(['daterange'].includes(quickSearchField.datatype.toLowerCase())) {
      validValueList[0] = this.userService.getFormatedDate(quickFieldValues[0]);
      validValueList[1] = validValueList[0];
    }

    return (validValueList.length > 0 ? validValueList : quickFieldValues);
  }

  clear() {
    // Clear All Quick Search Filters
    if(this.quickSearchDataArray.length > 0) {
      for (let i=0; i<this.quickSearchDataArray.length; i++) {
        this.quickSearchDataArray[i].values = '';
      }
    }

    this.gridService.clearQuickSearch(this.DefaultFilterArray, this.FilterFieldDefaultValues);
    /* Catch User Action Log */
      this.userService.logUserActivity("User Cleared Quick Search", this.constantService.getApplicationName(), {
        'Text1': this.userService.userFirstName + ' Cleared Quick Search Filter in ' + this.constantService.getApplicationName(),
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    this.clearQuickSearch.emit(this.DefaultFilterArray);
  }

}